import * as React from "react"
import { Hidden, Row, Visible } from "react-grid-system"
import { Link } from "react-router-dom"
import NavigationTextButton from "../atoms/buttons/NavigationTextButton"
import { Spacer } from "../atoms/spacers"
import styled from "styled-components"

interface Props {
  items: Array<{ title: string; url: string; value: string }>
  selectedItem: string
}

const MobileNav = styled.div`
  display: flex;
  width: 100%;
  overflow-x: scroll;
  margin-bottom: 2rem;
`

const SubpagesNavigationBar: React.FunctionComponent<Props> = ({ items, selectedItem }) => {
  return (
    <>
      <Visible xs>
        <MobileNav>
          {items.map((item) => (
            <Link to={item.url} key={item.value}>
              <div style={{ display: "flex" }}>
                <NavigationTextButton title={item.title} active={item.value === selectedItem} />
                <Spacer spacing={6} />
              </div>
            </Link>
          ))}
        </MobileNav>
      </Visible>
      <Hidden xs>
        <Row nogutter>
          {items.map((item) => (
            <Link to={item.url} key={item.value}>
              <div style={{ display: "flex" }}>
                <NavigationTextButton title={item.title} active={item.value === selectedItem} />
                <Spacer spacing={3} />
              </div>
            </Link>
          ))}
        </Row>
      </Hidden>
    </>
  )
}

export default SubpagesNavigationBar
